module.exports = __webpack_public_path__ + "img/serice-EDI.0b96fb5d.png";